class ComponentBlogFilter extends Theme.Component {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }

  filterBlog(detail, element) {
    const tag = element.dataset.tag;
    const baseUrl = this.dataset.blogUrl || window.location.pathname.split('/tagged/')[0];
    const url = tag ? `${baseUrl}/tagged/${this.handleize(tag)}` : baseUrl;

    this.updateActiveButton(element);
    this.fetchBlog(url);
  }

  async fetchBlog(url) {
    const requestUrl = new URL(url, window.location.origin);

    requestUrl.searchParams.set('section_id', this.dataset.sectionId);

    this.classList.add('loading');

    const response = await fetch(requestUrl.toString());

    const html = await response.text();

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nextBlog = doc.querySelector('[data-blog-filter]');

    if (!nextBlog) {
      window.location.href = url;
      return;
    }

    const currentArticles = this.querySelector('[data-blog-articles]');
    const nextArticles = nextBlog.querySelector('[data-blog-articles]');

    if (!currentArticles || !nextArticles) {
      window.location.href = url;
      return;
    }

    currentArticles.innerHTML = nextArticles.innerHTML;

    window.history.pushState({}, '', url);

    this.classList.remove('loading');
  }

  updateActiveButton(activeButton) {
    const buttons = this.querySelectorAll('.blog-filter-button');

    buttons.forEach((button) => {
      button.classList.toggle('active', button === activeButton);
    });
  }

  handleize(string) {
    const handle = string
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');

    return handle;
  }
}

customElements.define('component-blog-filter', ComponentBlogFilter);